import React, { useState, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react';
import useFetch from '../Utilities/useFetch';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Row, Col } from 'react-bootstrap'
import 'ag-grid-community/styles/ag-grid.css';

const ReportTemplateNoClick = ({
    columnDefs,
    apiUrl,
    reportName
}) => {
    // I fixed the format you had for the fetch call
    // I left your old code commented out so you could see the difference
    // const { data, error } =  useFetch(true, `${apiUrl}?reportDate=${date}`, 'GET');
    const { data, error } =  useFetch(true, apiUrl, 'GET', null);
    const [rowData, setRowData] = useState([]);
    const [gridApi, setGridApi] = useState();
    
    const onBtnExport = () => {
        const textColumns = ['clientRefNo', 'RefNo']; // columns to format as text
        gridApi.exportDataAsCsv({
        processCellCallback: (params) => {
            if (textColumns.includes(params.column.getColId())) {
                return params.value != null ? "'" + params.value : '';
            }
            return params.value;
        }
    });
    }
     const onGridReady = (params) => {
        setGridApi(params.api);
    }
    // I wrapped this if statement in a useEffect so react can keep better track of the state
    useEffect(()=>{
        if (error) {
            setRowData([]); // Clear data if the response is not OK
            console.error('Error fetching data:', error);
        }
    // because error is in this array, this will only run if error changes
    // eslint-disable-next-line
    },[error]);

    useEffect(() => {
        if (data) {
            setRowData(data);
        }
    }, [data]);
   
      
    // Not best practice to have code outside of useEffects, this code is already in a useEffect on line 26
    // if (error) {
    //     console.error('Error fetching data:', error);
    // }
 
 
    // I'm not sure the advantage of this component, but I left it as is
    // You could simply put the input in the ReportTemplateDateNoClick return statement
    

    return (
        <div>
            <Row>
                <Col>
                    <h4 className='margin'>{reportName}</h4>
                {error && <div className="error-message">Error fetching data: {error.message}</div>}
               </Col>
                <Col className='export-button'>
                    <Button variant='secondary' onClick={onBtnExport}>Download CSV</Button>
                </Col>

                </Row>
            <div className="ag-theme-quartz compact-theme grid">
                
                <AgGridReact
                    rowData={rowData}
                    columnDefs={columnDefs}
                    defaultColDef={{ sortable: true, filter: true }}
                    onGridReady={onGridReady}
                    onFirstDataRendered={(params) => params.api.sizeColumnsToFit()}
                />
            </div>
         </div>
    );
};

export default ReportTemplateNoClick;